// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */

/*-----------------------------------------------------------------------------
| Variables
|----------------------------------------------------------------------------*/

:root {
  --jp-private-running-item-height: 24px;
}

/*-----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/

.jp-RunningSessions {
  display: flex;
  flex-direction: column;
  min-width: var(--jp-sidebar-min-width);
  color: var(--jp-ui-font-color1);
  background: var(--jp-layout-color1);

  /* This is needed so that all font sizing of children done in ems is
   * relative to this base size */
  font-size: var(--jp-ui-font-size1);
}

.jp-RunningSessions > .jp-SidePanel-toolbar {
  justify-content: flex-end;
}

.jp-RunningSessions-section {
  min-height: 50px;
  overflow: auto;
}

.jp-RunningSessions-sectionContainer {
  margin: 0;
  padding: 0;
  overflow: auto;
}

.jp-RunningSessions-sectionList {
  display: block;
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.jp-RunningSessions-item {
  display: flex;
  flex-direction: row;
  color: var(--jp-ui-font-color1);
  height: var(--jp-private-running-item-height);
  line-height: var(--jp-private-running-item-height);
  padding: 0 8px;
}

.jp-RunningSessions-item:hover {
  background-color: var(--jp-layout-color2);
  cursor: pointer;
}

.jp-RunningSessions-item.jp-mod-running-child {
  padding-left: 40px;
}

.jp-RunningSessions-item.jp-mod-kernel:not(.jp-mod-running-child) {
  user-select: none;
}

.jp-RunningSessions-item img {
  height: 16px;
  margin-top: 4px;
}

.jp-RunningSessions-itemLabel {
  font-size: var(--jp-ui-font-size1);
  flex: 1 1 55%;
  padding: 0 4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.jp-RunningSessions-itemLabel:focus {
  background-color: var(--jp-layout-color2);
}

.jp-RunningSessions-itemDetail {
  font-size: var(--jp-ui-font-size1);
  flex: 1 1 45%;
  padding: 0 4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.jp-RunningSessions-item .jp-RunningSessions-itemShutdown {
  border-radius: 0;
}

.jp-RunningSessions-item:not(:hover) .jp-RunningSessions-itemShutdown {
  visibility: hidden;
}

.jp-RunningSessions-sectionList
  .jp-RunningSessions-item
  .jp-Button.jp-RunningSessions-itemShutdown:hover {
  background: var(--jp-layout-color3);
}

.jp-RunningSessions-shutdownAll.jp-mod-styled
  > .jp-ToolbarButtonComponent-label {
  color: var(--jp-warn-color1);
  background-color: transparent;
  border-radius: 2px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.jp-RunningSessions-shutdownAll.jp-mod-styled:hover
  > .jp-ToolbarButtonComponent-label {
  background-color: var(--jp-layout-color2);
}

.jp-RunningSessions-shutdownAll.jp-mod-styled:focus
  > .jp-ToolbarButtonComponent-label {
  border: none;
  box-shadow: none;
  background-color: var(--jp-layout-color2);
}

.jp-RunningSessions-shutdownAll.jp-mod-styled.jp-mod-disabled
  > .jp-ToolbarButtonComponent-label {
  color: var(--jp-ui-font-color2);
}

.jp-RunningSessions-shutdownAll.jp-mod-styled.jp-mod-disabled:hover
  > .jp-ToolbarButtonComponent-label {
  background: none;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@jupyterlab/running/style/base.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;;8EAE8E;;AAE9E;EACE,sCAAsC;AACxC;;AAEA;;;8EAG8E;;AAE9E;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,+BAA+B;EAC/B,mCAAmC;;EAEnC;iCAC+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,6CAA6C;EAC7C,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,mCAAmC;AACrC;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,gBAAgB;AAClB","sourcesContent":["/*\n * Copyright (c) Jupyter Development Team.\n * Distributed under the terms of the Modified BSD License.\n */\n\n/*-----------------------------------------------------------------------------\n| Variables\n|----------------------------------------------------------------------------*/\n\n:root {\n  --jp-private-running-item-height: 24px;\n}\n\n/*-----------------------------------------------------------------------------\n| Copyright (c) Jupyter Development Team.\n| Distributed under the terms of the Modified BSD License.\n|----------------------------------------------------------------------------*/\n\n.jp-RunningSessions {\n  display: flex;\n  flex-direction: column;\n  min-width: var(--jp-sidebar-min-width);\n  color: var(--jp-ui-font-color1);\n  background: var(--jp-layout-color1);\n\n  /* This is needed so that all font sizing of children done in ems is\n   * relative to this base size */\n  font-size: var(--jp-ui-font-size1);\n}\n\n.jp-RunningSessions > .jp-SidePanel-toolbar {\n  justify-content: flex-end;\n}\n\n.jp-RunningSessions-section {\n  min-height: 50px;\n  overflow: auto;\n}\n\n.jp-RunningSessions-sectionContainer {\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n}\n\n.jp-RunningSessions-sectionList {\n  display: block;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n\n.jp-RunningSessions-item {\n  display: flex;\n  flex-direction: row;\n  color: var(--jp-ui-font-color1);\n  height: var(--jp-private-running-item-height);\n  line-height: var(--jp-private-running-item-height);\n  padding: 0 8px;\n}\n\n.jp-RunningSessions-item:hover {\n  background-color: var(--jp-layout-color2);\n  cursor: pointer;\n}\n\n.jp-RunningSessions-item.jp-mod-running-child {\n  padding-left: 40px;\n}\n\n.jp-RunningSessions-item.jp-mod-kernel:not(.jp-mod-running-child) {\n  user-select: none;\n}\n\n.jp-RunningSessions-item img {\n  height: 16px;\n  margin-top: 4px;\n}\n\n.jp-RunningSessions-itemLabel {\n  font-size: var(--jp-ui-font-size1);\n  flex: 1 1 55%;\n  padding: 0 4px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.jp-RunningSessions-itemLabel:focus {\n  background-color: var(--jp-layout-color2);\n}\n\n.jp-RunningSessions-itemDetail {\n  font-size: var(--jp-ui-font-size1);\n  flex: 1 1 45%;\n  padding: 0 4px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.jp-RunningSessions-item .jp-RunningSessions-itemShutdown {\n  border-radius: 0;\n}\n\n.jp-RunningSessions-item:not(:hover) .jp-RunningSessions-itemShutdown {\n  visibility: hidden;\n}\n\n.jp-RunningSessions-sectionList\n  .jp-RunningSessions-item\n  .jp-Button.jp-RunningSessions-itemShutdown:hover {\n  background: var(--jp-layout-color3);\n}\n\n.jp-RunningSessions-shutdownAll.jp-mod-styled\n  > .jp-ToolbarButtonComponent-label {\n  color: var(--jp-warn-color1);\n  background-color: transparent;\n  border-radius: 2px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.jp-RunningSessions-shutdownAll.jp-mod-styled:hover\n  > .jp-ToolbarButtonComponent-label {\n  background-color: var(--jp-layout-color2);\n}\n\n.jp-RunningSessions-shutdownAll.jp-mod-styled:focus\n  > .jp-ToolbarButtonComponent-label {\n  border: none;\n  box-shadow: none;\n  background-color: var(--jp-layout-color2);\n}\n\n.jp-RunningSessions-shutdownAll.jp-mod-styled.jp-mod-disabled\n  > .jp-ToolbarButtonComponent-label {\n  color: var(--jp-ui-font-color2);\n}\n\n.jp-RunningSessions-shutdownAll.jp-mod-styled.jp-mod-disabled:hover\n  > .jp-ToolbarButtonComponent-label {\n  background: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
